/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsConfigSystemResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsConfigSystemResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsConfigSystemResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsConfigSystemResource>): RecommendationForFinopsConfigSystemResource {
        let obj = Object.assign(new RecommendationForFinopsConfigSystemResource(), model);
        RecommendationForFinopsConfigSystemResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsConfigSystemResource>): RecommendationForFinopsConfigSystemResource {
        if (!model) return null;
        return RecommendationForFinopsConfigSystemResource.newInstance(<RecommendationForFinopsConfigSystemResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsConfigSystemResource) {
        if (!obj) return;

        models.RecommendationForFinopsConfigSystemResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsConfigSystemResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsConfigSystemResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
